"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { StepContainer } from "../common.js";
import { OnRampProvider } from "@getpara/web-sdk";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { lazy, useEffect, useMemo, useState } from "react";
import { ModalStep } from "../../utils/steps.js";
import { RampEmbed } from "@getpara/react-common";
import styled from "styled-components";
import { useGoBack } from "../../hooks/useGoBack.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const STEPS = {
  CANCELLED: ModalStep.ADD_FUNDS_FAILURE,
  FINISHED: ModalStep.ADD_FUNDS_SUCCESS
};
const AddFundsAwaiting = () => {
  const setStep = useModalStore((state) => state.setStep);
  const goBack = useGoBack();
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const onRampPurchase = useModalStore((state) => state.onRampPurchase);
  const setOnRampPurchase = useModalStore((state) => state.setOnRampPurchase);
  const para = useInternalClient();
  const appName = useThemeStore((state) => state.appName);
  const isDark = useThemeStore((state) => state.isDark);
  const [MoonPayEmbed, setMoonPayEmbed] = useState(null);
  const props = {
    para,
    appName,
    onRampConfig,
    onRampPurchase,
    isDark,
    isEmbedded: true,
    setOnRampPurchase,
    onClose: goBack
  };
  useEffect(() => {
    const _MoonPayEmbed = lazy(() => import("./MoonPayEmbed.js"));
    setMoonPayEmbed(_MoonPayEmbed);
  }, []);
  const onRampEmbed = useMemo(() => {
    if (!onRampPurchase.id) {
      return null;
    }
    switch (onRampPurchase == null ? void 0 : onRampPurchase.provider) {
      case OnRampProvider.MOONPAY:
        return !MoonPayEmbed || typeof window === "undefined" ? null : /* @__PURE__ */ jsx(MoonPayEmbed, __spreadValues({}, props));
      case OnRampProvider.RAMP:
        return /* @__PURE__ */ jsx(RampEmbed, __spreadValues({ apiKey: onRampConfig.rampApiKey }, props));
      default:
        return null;
    }
  }, [onRampPurchase == null ? void 0 : onRampPurchase.provider, MoonPayEmbed]);
  useEffect(() => {
    let timeoutId;
    if ((onRampPurchase == null ? void 0 : onRampPurchase.status) && ["CANCELLED", "FINISHED"].includes(onRampPurchase.status)) {
      timeoutId = setTimeout(() => {
        setStep(STEPS[onRampPurchase.status]);
      }, 5e3);
    }
    return () => clearTimeout(timeoutId);
  }, [onRampPurchase == null ? void 0 : onRampPurchase.status]);
  return /* @__PURE__ */ jsx(Container, { $wide: true, children: onRampEmbed });
};
const Container = styled(StepContainer)`
  flex: 1;
`;
export {
  AddFundsAwaiting
};
